import * as React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import CssBaseline from "@mui/material/CssBaseline";

import { ButtonRoute } from "Pages/ButtonRoute";
import { RelatedListRoute } from "Pages/RelatedListRoute";
import { WebtabRoute } from "Pages/WebtabRoute";
import { HomePageRoute } from "Pages/HomePageRoute";
import { SettingsRoute } from "Pages/SettingsRoute";
import { ReactQueryProvider } from "providers/react-query-provider";
import { MUIThemeProvider } from "providers/mui-theme-provider";
import { ErrorBoundaryProvider } from "providers/error-boundary-provider";

// import "./util/env";
import { checkENVVariable } from "./util/env";

function App() {
  checkENVVariable();
  const router = createBrowserRouter([
    {
      path: "/buttons",
      element: <ButtonRoute />,
    },
    {
      path: "/relatedlist",
      element: <RelatedListRoute />,
    },
    {
      path: "/webtab",
      element: <WebtabRoute />,
    },
    {
      path: "/homepage",
      element: <HomePageRoute />,
    },
    {
      path: "/settings",
      element: <SettingsRoute />,
    },
    // {
    //   path: "/customaction",
    //   element: <CustomActionRoute />,
    // },
    // {
    //   path: "/businesscard",
    //   element: <Businesscard />,
    // },
  ]);
  return <RouterProvider router={router} />;
}

const Base = () => {
  return (
    <React.Fragment>
      <ErrorBoundaryProvider>
        <SnackbarProvider>
          <ReactQueryProvider>
            <MUIThemeProvider>
              <CssBaseline />
              <App />
            </MUIThemeProvider>
          </ReactQueryProvider>
        </SnackbarProvider>
      </ErrorBoundaryProvider>
    </React.Fragment>
  );
};

export default Base;
